import axios from "../config"

class PageService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getPage( customerOrPage) {
      let url = `/page`
      return axios.get(url,{
        params:{
          customerOrPage
        }
      }
      ).then(request => request.data);
    }
    addPage(page) {
      let url = `/page`;
      return this.axios.post(url, page).then(request => request.data);
    }
    updatePage(page) {
      let url = `/page/${page.pageId}`;
      return this.axios.put(url, page).then(request => request.data);
    }
    deletePage(page) {
      let url = `/page/${page.pageId}`;
      return this.axios.delete(url).then(request => request.data);
    }
    getPagePhoto(formData,pageId){
      let url = `page/${pageId}/photo`;
      return axios.put(url, formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          }).then(request => request.data);
    }
    getPageHeaderPhoto(formData,pageId){
      let url = `page/${pageId}/headerphoto`;
      return axios.put(url, formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          }).then(request => request.data);
    }
    getPageUser(pageId,userType) {
      let url = `/page/user`
      return axios.get(url,{
        params:{
          pageId,userType
        }
      }).then(request => request.data);
    }
    addPageUser(pageuser) {
      let url = `/page/user`;
      return this.axios.post(url, pageuser).then(request => request.data);
    }
   
    deletePageUser(pageuser) {
      let url = `/page/user/${pageuser.pageUserId}`;
      return this.axios.delete(url).then(request => request.data);
    }
    getPageById(pageId) {
      let url = `/page/${pageId}`
      return axios.get(url).then(request => request.data);
    }
    getPageBySearch(search) {
      let url = `/page/search`
      return axios.get(url,{
        params:{
          search
        }
      }).then(request => request.data);
    }
    updateUserStatus(pageUserId,userTypeId,noOryes,userTypeName,notiId,userTypeChange) {
      let url = `/page/userstatus`;
      return this.axios.get(url,{
        params:{
          pageUserId,userTypeId,noOryes,userTypeName,notiId,userTypeChange
        }
      }).then(request => request.data);
    }
    updateMessageLook(pageId,customerOrPage,customerId) {
      let url = `/page/${pageId}/look/${customerOrPage}/${customerId}`;
      return this.axios.put(url).then(request => request.data);
    }
}

const service = new PageService();
export default service;